import {
  cachingService,
  LocalLookupService,
} from "@ofqual/portal-core/core/dataAccess";
import {
  API_HOST_COMMS,
  API_HOST_ORGS,
  API_HOST_REFDATA,
  API_HOST_SEARCH,
  API_HOST_SVR,
  API_HOST_USERS,
} from "../config";
import { EventNotificationsService } from "./EventNotificationsService";
import { ExamSeriesService } from "./ExamSeriesService";
import { ExamSeriesYearsService } from "./ExamSeriesYearsService";
import { GeneralConditionsService } from "./GeneralConditionsService";
import { GeneralSubConditionsService } from "./GeneralSubConditionsService";
import { QualificationConditionsService } from "./QualificationConditionsService";
import { SubjectConditionsService } from "./SubjectConditionsService";
import yesNo from "./json/yesNo.json";
import inboxTypes from "./json/inboxTypes.json";
import inboxStatus from "./json/inboxStatus.json";
import caoRequestTypes from "./json/caoRequestTypes.json";

import { QualificationReferenceServiceSearch } from "./QualificationReferenceServiceSearch";
import { QualificationReferenceService } from "./QualificationReferenceService";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { AwardingOrgService } from "./AwardingOrgService";
import { UserService } from "./UserService";
import { ShareService } from "./ShareService";
import { WhoIsAwareService } from "./WhoIsAwareService";
import { AdverseEffectOutcomeService } from "./AdverseEffectOutcomeService";
import { AoEngagementService } from "./AoEngagementService";
import { AssessmentModificationTypeService } from "./AssessmentModificationTypeService";
import { AssessmentPaperTypeService } from "./AssessmentPaperTypeService";
import { AssessmentWhenIdentifiedService } from "./AssessmentWhenIdentifiedService";
import { AssessmentWhoIdentifiedService } from "./AssessmentWhoIdentifiedService";
import { CentreNumberTypeService } from "./CentreNumberTypeService";
import { DirectorateService } from "./DirectorateService";
import { DisagreeAoDeclarationReasonService } from "./DisagreeAoDeclarationReasonService";
import { EventSubTypeService, EventTypeService } from "./EventTypeService";
import { FinalDeterminationService } from "./FinalDeterminationService";
import { MalpracticeAllegationService } from "./MalpracticeAllegationService";
import { MitigationsTakenService } from "./MitigationsTakenService";
import { PreventReoccurrenceService } from "./PreventReoccurrenceService";
import { OfqualActionTakenService } from "./OfqualActionTakenService";
import { RiskCategoryService } from "./RiskCategoryService";
import { RootCauseService } from "./RootCauseService";
import { SecurityIncorrectPaperOutcomeService } from "./SecurityIncorrectPaperOutcomeService";
import { SecurityMeansOfBreachService } from "./SecurityMeansOfBreachService";
import { InformationRequestService } from "./InformationRequestService";
import { TagsService } from "./TagsService";
import { ResourceTagsService } from "./ResourceTagsService";
import amPmJson from "./json/amPm.json";
import { AmeAssessmentMethodService } from "./AmeAssessmentMethodService";

export const eventNotificationsService = new EventNotificationsService(
  API_HOST_COMMS
);
export const examSeriesService = new ExamSeriesService(API_HOST_REFDATA);
export const examSeriesYearService = new ExamSeriesYearsService(
  API_HOST_REFDATA
);
export const generalConditionsService = new GeneralConditionsService(
  API_HOST_REFDATA
);
export const generalSubConditionsService = new GeneralSubConditionsService(
  API_HOST_REFDATA
);

export const qualificationConditionsService = new QualificationConditionsService(
  API_HOST_REFDATA
);
export const subjectConditionsService = new SubjectConditionsService(
  API_HOST_REFDATA
);
export const qualificationReferenceService = new QualificationReferenceService(
  API_HOST_REFDATA
);
export const qualificationReferenceServiceSearch = new QualificationReferenceServiceSearch(
  API_HOST_SEARCH
);

export const resourceTagsService = new ResourceTagsService(API_HOST_SVR);


export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const aoServiceRefData = new AwardingOrgService(API_HOST_ORGS);
export const cachingAoService = cachingService(aoServiceRefData);
export const usersService = new UserService(API_HOST_USERS);
export const shareService = new ShareService(API_HOST_COMMS);

export const whoAwareService = new WhoIsAwareService(API_HOST_REFDATA);
export const centreNumberTypeService = new CentreNumberTypeService(
  API_HOST_REFDATA
);

export const assessmentModificationTypeService = new AssessmentModificationTypeService(
  API_HOST_REFDATA
);
export const assessmentPaperTypeService = new AssessmentPaperTypeService(
  API_HOST_REFDATA
);
export const assessmentWhenIdentifiedService = new AssessmentWhenIdentifiedService(
  API_HOST_REFDATA
);
export const assessmentWhoIdentifiedService = new AssessmentWhoIdentifiedService(
  API_HOST_REFDATA
);
export const ameAssessmentMethodService = new AmeAssessmentMethodService(
  API_HOST_REFDATA
);

export const yesNoService = new LocalLookupService(yesNo);
export const securityIncorrectPaperOutcomeService = new SecurityIncorrectPaperOutcomeService(
  API_HOST_REFDATA
);
export const securityMeansOfBreachService = new SecurityMeansOfBreachService(
  API_HOST_REFDATA
);
export const eventTypeService = new EventTypeService(API_HOST_REFDATA);
export const eventSubTypeService = new EventSubTypeService(API_HOST_REFDATA);
export const riskCategoryService = new RiskCategoryService(API_HOST_REFDATA);
export const rootCauseService = new RootCauseService(API_HOST_REFDATA);
export const mitigationsTakenService = new MitigationsTakenService(
  API_HOST_REFDATA
);
export const preventReoccurrenceService = new PreventReoccurrenceService(API_HOST_REFDATA);
export const ofqualActionTakenService = new OfqualActionTakenService(
  API_HOST_REFDATA
);
export const adverseEffectOutcomeService = new AdverseEffectOutcomeService(
  API_HOST_REFDATA
);
export const disagreeWithAoDeclarationReasonService = new DisagreeAoDeclarationReasonService(
  API_HOST_REFDATA
);
export const finalDeterminationService = new FinalDeterminationService(
  API_HOST_REFDATA
);
export const aoEngagementService = new AoEngagementService(API_HOST_REFDATA);
export const malpracticeAllegationService = new MalpracticeAllegationService(
  API_HOST_REFDATA
);
export const directorateService = new DirectorateService(API_HOST_REFDATA);
export const inboxTypesService = new LocalLookupService(inboxTypes);
export const inboxStatusService = new LocalLookupService(inboxStatus);
export const caoRequestTypeService = new LocalLookupService(caoRequestTypes);

export const informationRequestService = new InformationRequestService(
  API_HOST_COMMS
);
export const tagsService = new TagsService(API_HOST_REFDATA);
export const amPmService = new LocalLookupService(amPmJson)
